// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2MMZ4","requiredAsterisk":"Info_requiredAsterisk__QZ8eP"};